import { Injectable } from '@angular/core';
import { map, tap } from 'rxjs';
import { MapFilterState } from './map-filter-state.model';
import {
  CacheFactoryService,
  ICacheService,
} from 'app/shared/services/cache-factory.service';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class FiltersService {
  private cacheService: ICacheService;

  constructor(private http: HttpClient, cacheFactory: CacheFactoryService) {
    this.cacheService = cacheFactory.getOrCreate('map-filters');
  }

  listFilterStates() {
    return this.cacheService.getCached({
      path: 'listFilterStates',
      source: () => {
        return this.http.get<MapFilterState[]>(`~CustomFilter`).pipe(
          map((states) => {
            states = states.map((state) => new MapFilterState(state));
            return states;
          })
        );
      },
    });
  }

  saveFilterState(state: MapFilterState) {
    return this.http.post<any>(`~CustomFilter`, state).pipe(
      tap(() => {
        this.cacheService.removeCache('listFilterStates');
      })
    );
  }

  deleteFilterState(filterId: string) {
    return this.http.delete<any>(`~CustomFilter/${filterId}`).pipe(
      tap(() => {
        this.cacheService.removeCache('listFilterStates');
      })
    );
  }
}
